export const handleReactionIcon = (reaction: string) => {
  const actions = {
    like: 'thumbs-up',
    love: 'heart',
    celebrate: 'party-horn',
    funny: 'face-smile',
    insightful: 'lightbulb-04',
  }
  return actions[reaction as keyof typeof actions] ?? 'thumbs-up'
}
